import * as React from 'react';
import { useHistory } from 'react-router-dom';
import ApSchedulerContactsList from '../../../components/Contact/Communicator/ApSchedulerContactsList/ApSchedulerContactsList';
import PageStatus from '../../../components/Navigation/PageStatus/PageStatus';
import useAsyncGetListContactsLite from '../../../hooks/useAsyncGetListContactsLite';
import { RequestStatus } from '../../../sic-lib/enums/RequestStatus';
import { ApSchedulerRouteState } from '../../../sic-lib/types/ApSchedulerRouteState';
import { buildGetListContacts } from '../../../sic-lib/types/ListContact';
import { mapContactToApSchedulerContact } from '../../../sic-lib/utils/functionalMappers';
import { setContacts } from '../../../store/communicator';
import { clearSelected } from '../../../store/conversationGrid';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import CommContactsSelect from '../CommContactsSelect/CommContactsSelect';

export default function SectionContacts() {
    const dispatch = useAppDispatch();
    const history = useHistory<ApSchedulerRouteState>();

    const { requestStatus, asyncGetListContacts } = useAsyncGetListContactsLite();

    React.useEffect(() => {
        const contactIds = history.location?.state?.apContactIds || [];
        const listId = history.location?.state?.apListId || undefined;
        const routeFrom = history.location?.state?.apRouteFrom || undefined;

        /* clear values from history */
        history.location?.state?.apContactIds && delete history.location.state.apContactIds;
        history.location?.state?.apListId && delete history.location.state.apListId;
        history.location?.state?.apRouteFrom && delete history.location.state.apRouteFrom;

        /*
            clear selected contacts if they were injected through a mass action

            FIX: adding the call to clear selected contacts on button click added
            extra time to the route change.
         */
        if (routeFrom === 'newRecent') {
            // dispatch(clearSelected());
        } else if (routeFrom === 'conversationGrid') {
            dispatch(clearSelected());
        }

        async function request() {
            const reqObj = buildGetListContacts({ listId, contactIds });

            const asyncResult = await asyncGetListContacts(reqObj);

            if (asyncResult) {
                const contacts = asyncResult.map(mapContactToApSchedulerContact);

                dispatch(setContacts(contacts));
            }
        }

        /* 
            Contacts injected into ApScheduler in one of two ways:
            1. a number[] of contact ids
            2. a number representing listId

            Either option is delivered through react-router location state
         */
        if (contactIds.length > 0 || listId !== undefined) {
            request();
        }
    }, [history.location]);

    const commContacts = useAppSelector(state => {
        return state.communicator?.contacts || [];
    });

    return (
        <PageStatus
            showError={requestStatus === RequestStatus.error}
            showLoading={requestStatus === RequestStatus.active}
        >
            <div className="apScheduler__panel--left">
                {commContacts.length < 1 && <CommContactsSelect />}
                {commContacts.length > 0 && <ApSchedulerContactsList />}
            </div>
        </PageStatus>
    );
}
